import { useEffect, useState, useRef } from 'react';
import { useDispatch, useSelector, connect } from 'react-redux';
import { FormattedMessage, injectIntl, WrappedComponentProps } from 'react-intl';
import { ThunkDispatch } from 'redux-thunk';
import { Action } from 'redux';
import { RouteComponentProps, withRouter } from 'react-router-dom';

import { useLocation } from 'react-router-dom';
import DashboardAside from '../../components/dashboard2/dashboard-aside/component';
import TopNav from '../../components/dashboard2/top-nav/component';
import HotelCard from '../../components/dashboard/hotel-card/component';
import { Base64 } from 'js-base64';
import HotelCardSkeleton from '../../components/dashboard/hotel-card-skeleton/component';
import InfiniteScroll from 'react-infinite-scroll-component';
import ErrorMessage from '../../components/common/error-message/component';
import { QUERY_PARAMS } from '../../../constants/index';
import { getSavedProperties, ISavedPropertiesState } from '@store/slices';
import { axiosInstance } from '@share/utils';
import { Urls } from '@share/constants';
import CondoMapPlaceholder from '@assets/images/condo-map-placeholder.jpg';
import MapMarker from '@assets/images/map-bed-marker.svg';
import { Map } from '@utils';
import './style.scss';
import debounce from 'lodash/debounce';

import { get } from 'lodash';

import { MapWrapper, WalletSearchSlider, Banner } from '@components';
import {
  filtersActions,
  resetHotels,
  resetHotelsFull,
  getHotels,
  getSimilarHotels,
  getMapHotels,
  hotelsActions,
  IDatesState,
  IFiltersState,
  IHotelsState,
  ILocationsState,
  IRoomsState,
  locationActions,
  ILoginState,
  loginActions,
  getUserWallet,
  IFilterType,
} from '@share/store/slices';
import { getAccountUsernameFromPath, RootState, VACATIONS_PAGE, GetHomeParams } from '@share/utils';
import {
  IAccount,
  IBounds,
  IClientCash,
  IHotel,
  ILocation,
  IPublicPrice,
  IRating,
  IRoom,
  IUser,
  SEARCH_BANNER_TYPE,
} from '@share/common-types';
import {
  APP_SELECTOR,
  NULL_VALUE,
} from '@constants';
import {
  DEFAULT_PAGE_SIZE,
  HomesTypes,
  Routes,
  SortTypes,
} from '@share/constants';
import {
  isDataValid,
} from '@share/utils';
import HotelPointCardSkeleton from '../../components/dashboard/hotel-point-card-skeleton/component';
import { Modal } from 'antd';
import { BlueButton } from '@share/components';
import { IAmenities, IPossibleStay } from '@common-types';

interface HotelImage {
  src: string;
  alt: string;
}

interface Hotel {
  hotelId: number;
  displayName: string;
  starRating: number;
  countryCode: string;
  zipCode: string;
  originalPrice?: number;
  discountedPrice?: number;
  totalPrice?: number;
  refundable?: boolean;
  images?: HotelImage[];
  currency: string;
  savedProperty: boolean;
  address?: string;
  rating?: IRating;
  publicPrices?: IPublicPrice[];
  price?: number;
  amenities?: IAmenities[];
  accommodationType?: string;
  boardName?: string;
  pricePerNight?: number;
  city?: string;
  state?: string;
  refundability?: string;
  savings?: number;
  tag?: string;
  isPackage?: boolean;
  exactSearch?: boolean;
  availability?: string;
  supplierId?: string;
  possibleStays?: IPossibleStay[];
  mealPLan?: string;
  maxWalletClientCash?: number;
}

interface IMapStateToProps {
  hotelsStore: IHotelsState;
  datesStore: IDatesState;
  locationsStore: ILocationsState;
  roomsStore: IRoomsState;
  filtersStore: IFiltersState;
  loginStore: ILoginState;
  savedPropertiesStore: ISavedPropertiesState;
}

interface IMapDispatchToProps {
  setPageNumber: () => void;
  getUserWallet: (user: IUser) => void;
  getHotels: (
    location: ILocation,
    isLoadMore: boolean,
    isFiltersChange: boolean,
  ) => void;
  getSimilarHotels: (isFiltersChange: boolean, isLoadMore: boolean) => void;
  resetHotels: () => void;
  resetHotelsFull: () => void;
  setBudget: (value: string[]) => void;
  setMapLoading: (isMapLoading: boolean) => void;
  setAmenities: (value: string[]) => void;
  setAccommodationType: (value: string[]) => void;
  setAccessibility: (value: string[]) => void;
  setPopularLocations: (value: string[]) => void;
  setBoardName: (value: string[]) => void;
  setRefundable: (value: string[]) => void;
  setFlexibleDate: (value: string[]) => void;
  setNeighbourhoods: (value: string[]) => void;
  setPlaces: (value: string[]) => void;
  setStarRating: (value: number[]) => void;
  setDistance: (value: number) => void;
  setSortBy: (value: string) => void;
  setSelectedCompareHotels: (selectedCompareHotels: IHotel[]) => void;
  resetFiltersByType: (type: IFilterType) => void;
  getMapHotels: (
    location: ILocation,
    startDate: string,
    endDate: string,
    rooms: IRoom[],
    hotelId?: number,
  ) => void;
  validateLocation: (error: string) => void;
  setBounds: (bounds: IBounds) => void;
  setIsMapView: (isMapView: boolean) => void;
  setSearchHomes: (value: string) => void;
  setSelectedHotelSearchClientCash: (selectedClientCash: IClientCash) => void;
  setLifeStyle: (value: string) => void;
}

interface IProps extends IMapStateToProps, IMapDispatchToProps, WrappedComponentProps, RouteComponentProps {
  label: string;
  isVacationRentals: boolean | null | undefined;
  matches?: boolean;
}

const debounceTime = 300;
const scrollPixels = 450;
const zero = 0;

function DashboardSearchComponent(props: IProps) {

  const root: HTMLDivElement | null = document.querySelector(APP_SELECTOR);

  const divRef = useRef(null);

  const checkIsLocationValid = (): boolean => {
    const { datesStore, locationsStore, validateLocation, intl } = props;
    const { isLocationValid } = isDataValid(locationsStore, datesStore);

    if (!isLocationValid) {
      validateLocation(intl.formatMessage({ id: 'location.error' }));
      return false;
    }

    return true;
  };

  const checkInView = () => {
    const rect = (divRef?.current as any)?.getBoundingClientRect();

    setIsInView(!divRef?.current || (rect?.top < window.innerHeight && rect?.bottom >= 0));
  };

  const onScroll = debounce(() => {
    const {
      setPageNumber,
      getHotels,
      getSimilarHotels,
      locationsStore,
      hotelsStore,
    } = props;
    const { loadingMore, hotels, similarHotels, prevHotels, isSessionExpired, lastSearchedLocation } = hotelsStore;
    const { selectedLocation, location } = locationsStore;

    if (!lastSearchedLocation && !selectedLocation) {
      checkIsLocationValid();
    }

    const rootHeightCheck = root?.scrollHeight ? root.scrollHeight : root?.offsetHeight;
    const rootHeight = rootHeightCheck ? rootHeightCheck : 0;
    if (!isSessionExpired &&
      !loadingMore &&
      root &&
      window.innerHeight + window.scrollY + scrollPixels >= rootHeight
    ) {
      setPageNumber();

      if (hotels &&
        hotels.length &&
        hotels.length % DEFAULT_PAGE_SIZE === zero &&
        prevHotels.length) {
        getHotels(
          lastSearchedLocation,
          true,
          false,
        );
      } else if (location?.type === 'Hotel' &&
        similarHotels &&
        similarHotels.length &&
        similarHotels.length % DEFAULT_PAGE_SIZE === zero) {
        getSimilarHotels(false, true);
      }
    }
  }, debounceTime);

  useEffect(() => {
    checkInView();

    // window.history.pushState(null, NULL_VALUE, window.location.pathname + window.location.search);
    window.addEventListener('popstate', onClickBackButton);
    window.addEventListener('scroll', onScroll);

    document.addEventListener('scroll', checkInView);

    return () => {
      window.removeEventListener('scroll', onScroll);
      window.removeEventListener('popstate', onClickBackButton);

      document.removeEventListener('scroll', checkInView);

      const footer: HTMLDivElement | null = document.querySelector('.footer');

      if (footer) {
        document.body.style.overflow = 'auto';
        footer.style.display = 'block';
      }
    }

  }, []);

  const onClickBackButton = (e: any) => {
    e.preventDefault();

    const accountName = getAccountUsernameFromPath(props.history);

    const { loginStore } = props;
    const { account } = loginStore;

    const homeParams = GetHomeParams(account as IAccount);

    if (props.isVacationRentals) {
      props.history.push(`/${accountName}${Routes.Search}/${VACATIONS_PAGE}${homeParams}`);
    } else {
      // props.history.push(`/${accountName}/dashboard`);
      // props.history.push(`/${accountName}${Routes.Search}${homeParams}`);
    }

    // window.location.reload();
  }

  const handleOnSelectClientCash = (selectedSearchClientCash: number) => {
    const { hotelsStore } = props;
    const { selectedHotelSearchClientCash } = hotelsStore;

    const clientCash = { ...selectedHotelSearchClientCash, selectedSearchClientCash };
    props.setSelectedHotelSearchClientCash(clientCash);
  }

  const location = useLocation();
  const dispatch = useDispatch();
  const loginStore = useSelector((state: { loginStore: ILoginState }) => state.loginStore);
  const hotelsStore = useSelector((state: { hotelsStore: IHotelsState }) => state.hotelsStore);
  const savedPropertiesStore = useSelector((state: IMapStateToProps) => state.savedPropertiesStore);
  const login = useSelector((state: { loginStore: ILoginState }) => state.loginStore);
  const { account } = login;
  const currency = String(account?.currency ?? 'USD');
  const queryParams = new URLSearchParams(location.search);
  const locationQuery = queryParams.get(QUERY_PARAMS.LOCATION);
  const roomsQuery = queryParams.get(QUERY_PARAMS.ROOMS);
  const dateQuery = queryParams.get(QUERY_PARAMS.DATE);
  const locationData = Base64.decode(locationQuery || '');
  const parsedLocationData = JSON.parse(locationData) || [];
  const roomsData = Base64.decode(roomsQuery || '');
  const parsedRoomsData = JSON.parse(roomsData) || [];
  const datesData = Base64.decode(dateQuery || '');
  const parsedDate = JSON.parse(datesData) || [];
  const { checkIn, checkOut } = parsedDate;
  
  const [isInView, setIsInView] = useState(false);
  const [searchHotels, setSearchHotels] = useState<Hotel[]>([]);
  const [counters, setCounters] = useState({});
  const [loading, setLoading] = useState(true);
  const [hasMore, setHasMore] = useState(true);
  const [sessionKey, setSessionKey] = useState({});
  const [pageNumber, setPageNumber] = useState(1);
  const [isMapView, setIsMapView] = useState(false);
  const [mapLocation, setMapLocation] = useState<{ location: { latitude: number, longitude: number }, id: number }[]>([]);
  const [bonds, setBonds] = useState<any>();
  const [payload, setPayload] = useState({
    hotelsRequest: {
      residency: 'US',
      locationCode: '657822',
      location: parsedLocationData || [],
      checkIn: checkIn || [],
      checkOut: checkOut || [],
      rooms: parsedRoomsData || [],
    },
    filter: {
      accessibilities: [],
      accommodationType: [],
      amenities: [],
      boardNames: [],
      budgetRanges: [],
      neighbourhoods: [],
      popularLocations: [],
      refundable: [],
      starRatings: [],
      propertyName: "",
      distanceInMiles: 10,
      exactSearch: true,
    },
    sortBy: 'BiggestSavingsPercentage',
    pageNumber: 1,
    pageSize: 10,
    quick: false,
    searchHomes: 'All',
    currency: currency,
    sessionKey: null
  });

  async function fetchHotels(payload: any, loadingFunc?: any) {
    if (loadingFunc) {
      loadingFunc();
    }
    try {

      dispatch(getSavedProperties);

      const { data: result } = await axiosInstance.post(Urls.HotelsSearch, payload);

      const totalPages = Math.ceil(result?.counters?.totalFilteredHotels / payload.pageSize);

      if (payload.pageNumber < totalPages) {
        setHasMore(true);
      } else {
        setHasMore(false);
      }

      if (loadingFunc) {
        setSearchHotels(result?.searchHotels);
      } else {
        setSearchHotels((prev) => [...prev, ...result?.searchHotels]);
      }
      setCounters(result?.counters);
      setSessionKey(result?.sessionKey);
      setBonds(result?.bounds);
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  }

  useEffect(() => {
    setPayload({
      ...payload,
      hotelsRequest: {
        ...payload.hotelsRequest,
        location: parsedLocationData,
        checkIn: checkIn || [],
        checkOut: checkOut || [],
        rooms: parsedRoomsData || [],
      },
      pageNumber: 1,
      //sessionKey:sessionKey
    });

    fetchHotels(
      {
        ...payload,
        hotelsRequest: {
          ...payload.hotelsRequest,
          location: parsedLocationData,
          checkIn: checkIn || [],
          checkOut: checkOut || [],
          rooms: parsedRoomsData || [],
        },
        pageNumber: 1,
        //sessionKey:sessionKey
      },
      () => {
        setLoading(true);
      },
    );
  }, [locationQuery, dateQuery, roomsQuery]);

  const { process } = savedPropertiesStore;
  
  useEffect(() => {
    if (process) {
      let hotel = searchHotels.find(x => x.hotelId == process.id);
      if (hotel) {
        hotel.savedProperty = process.added;
      }
      setSearchHotels(searchHotels);
    }
  }, [process]);

  useEffect(() => {
    const mapData = searchHotels.map((hotel) => ({
      location: {
        latitude: hotel.location.latitude,
        longitude: hotel.location.longitude,
      },
      id: hotel.hotelId,
    }));
    setMapLocation(mapData);
    
    setMapLocation(mapData);
  }, [searchHotels]);
  const walletHasSliderOnSearch = loginStore?.account?.walletHasSliderOnSearch;

  const getCenterFromBounds = (bounds:any) => {
    const avgLat = (bounds.southWest.latitude + bounds.northEast.latitude) / 2;
    const avgLng = (bounds.southWest.longitude + bounds.northEast.longitude) / 2;
    return Map.getGoogleLocation({ latitude: avgLat, longitude: avgLng });
  };
  
  return (
    <>
      <TopNav
        location={parsedLocationData}
        checkInDate={checkIn}
        checkOutDate={checkOut}
        rooms={parsedRoomsData}
        setPageNumber={setPageNumber}
      />
      {searchHotels?.length > 0 && <div className='container d-flex justify-content-start'>
        <BlueButton className='btn btn-primary mb-3 commonBlueBtn' onClick={() => setIsMapView(true)}><i className="bi bi-geo-alt-fill me-2"></i><FormattedMessage id="view.on.map" /></BlueButton>
      </div>}
      <section className="pt-0">
        <div className="container">
          <div className="row">
            <DashboardAside
              setSearchHotels={setSearchHotels}
              setLoading={setLoading}
              fetchHotels={fetchHotels}
              payload={payload}
              setPayload={setPayload}
              setPageNumber={setPageNumber}
              counters={counters}
              searchHotels={searchHotels}
              loading={loading}

              isInView={isInView}
              walletHasSliderOnSearch={walletHasSliderOnSearch}
              selectedClientCash={hotelsStore?.selectedHotelSearchClientCash?.selectedSearchClientCash as number}
              onSelectClientCash={handleOnSelectClientCash}
            />

            <div className={'col-xl-8 col-xxl-9 mx-auto'}>
              <div className="vstack gap-4">
                {!searchHotels?.length && !loading ? (
                  <ErrorMessage
                    heading="Oops! We got lost on the way..."
                    subHeading="For some reason we did not find any result for your search in"
                    text="Don't worry! Try again but changing your search criteria"
                  />
                ) : loading ? <>
                {/* {[...Array(1)].map((_, index) => <HotelPointCardSkeleton key={`skeleton-2-${index}`} />)} */}
                {[...Array(3)].map((_, index) => <HotelCardSkeleton key={`skeleton-1-${index}`} />)}
              </> : (
                  <InfiniteScroll
                    style={{ overflow: 'visible' }}
                    dataLength={pageNumber * 10}
                    next={async () => {
                      await fetchHotels({
                        ...payload,
                        sessionKey: sessionKey,
                        pageNumber: pageNumber + 1,
                      });
                      setPageNumber((prev) => prev + 1);
                    }}
                    hasMore={hasMore}
                    loader={[...Array(2)]?.map((_, index) => (
                      <HotelCardSkeleton key={index} />
                    ))}
                  >

                    {/* {walletHasSliderOnSearch ? (
                      <div className="card shadow p-2 mb-4 result-wrapper__top-section top-0 z-index-1" ref={divRef}>
                        <WalletSearchSlider
                          display={true}
                          selectedClientCash={hotelsStore?.selectedHotelSearchClientCash?.selectedSearchClientCash as number}
                          onSelectClientCash={handleOnSelectClientCash}
                        />
                      </div>) : null} */}

                    {searchHotels?.length > 0 &&
                      searchHotels?.map((hotel: any, i) => (
                        <>
                          <HotelCard
                            key={i}
                            sessionKey={sessionKey}
                            hotelId={hotel.hotelId}
                            decryptedData={payload}
                            images={hotel.images}
                            counters={counters}
                            details={{
                              name: hotel.displayName,
                              location: `${hotel.address}${hotel.city ? `, ${hotel.city}` : ''}${hotel.state ? `, ${hotel.state}` : ''}${hotel.zipCode ? `, ${hotel.zipCode}` : ''}`,
                              guestReviews: hotel?.rating?.value,
                              guestReviewsCount: hotel?.rating?.reviewsCount,
                              ratingStars: hotel?.starRating,
                              ratingHalf: hotel?.starRating % 10 === 5,
                              savings: hotel?.savings || 0,
                              public_price: (hotel?.publicPrices && hotel?.publicPrices[0]?.price) || 0,
                              pricePerNight: hotel?.pricePerNight || 0,
                              totalPrice: hotel?.price || 0,
                              refundable: hotel?.refundability || false,
                              currency: hotel?.currency || 'USD',
                              savedProperty: hotel?.savedProperty || false,
                              maxWalletClientCash: hotel?.maxWalletClientCash
                            }}
                            disabled={hotelsStore?.isSessionExpired}
                            hotel={hotel}
                            nights={!hotel?.possibleStays?.length ? (counters as any)?.totalNights : get(hotel, 'possibleStays[0].days', 0)}
                            compared={false}
                            displayCompare={false}
                            disableCompare={true}
                            isVacationRentals={false}
                          />
                          {i === 1 && <span className='searchBanner'><Banner type={SEARCH_BANNER_TYPE} /></span>}
                        </>
                      ))}
                  </InfiniteScroll>
                )}
              </div>
            </div>
            <Modal
              open={isMapView}
              title={'Map View'}
              onCancel={() => setIsMapView(false)}
              width={1400}
              footer={[]}
            >
              <div
                className={`condo-result-wrapper__map-content`}
                style={{ backgroundImage: `url(${CondoMapPlaceholder})` }}
                  >
                  <MapWrapper
                    locations={mapLocation}
                    icon={MapMarker}
                    mapOptions={{ zoom: 4, disableDefaultUI: true }}
                    bounds={bonds}
                    hotels={searchHotels as any}
                    isVacationRentals={false}
                    sessionKey={sessionKey}
                    isHotel={true}
                    withEvents={true}
                  />
              </div>
            </Modal>
          </div>
        </div>
      </section>
    </>
  );
};

const mapStateToProps = (state: RootState): IMapStateToProps => {
  return {
    hotelsStore: state.hotelsStore,
    datesStore: state.datesStore,
    locationsStore: state.locationsStore,
    roomsStore: state.roomsStore,
    filtersStore: state.filtersStore,
    loginStore: state.loginStore,
    savedPropertiesStore: state.savedPropertiesStore
  };
};

const mapDispatchToProps = (
  dispatch: ThunkDispatch<RootState, undefined, Action>,
): IMapDispatchToProps => ({
  setPageNumber: () => {
    dispatch(hotelsActions.setPageNumber());
  },
  resetHotels: () => {
    dispatch(resetHotels());
  },
  resetHotelsFull: () => {
    dispatch(resetHotelsFull());
  },
  getHotels: (
    location: ILocation,
    isLoadMore: boolean,
    isFiltersChange: boolean,
  ) => {
    dispatch(getHotels(location, isLoadMore, isFiltersChange));
  },
  getMapHotels: (
    location: ILocation,
    startDate: string,
    endDate: string,
    rooms: IRoom[],
    hotelId: number = NULL_VALUE,
  ) => {
    dispatch(getMapHotels(location, startDate, endDate, rooms, hotelId));
  },
  getSimilarHotels: (isFiltersChange: boolean, isLoadMore: boolean) => {
    dispatch(getSimilarHotels(isFiltersChange, isLoadMore));
  },
  setBudget: (value: string[]) => {
    dispatch(filtersActions.setBudget(value));
  },
  setAmenities: (value: string[]) => {
    dispatch(filtersActions.setAmenities(value));
  },
  setAccommodationType: (value: string[]) => {
    dispatch(filtersActions.setAccommodationType(value));
  },
  setAccessibility: (value: string[]) => {
    dispatch(filtersActions.setAccessibility(value));
  },
  setPopularLocations: (value: string[]) => {
    dispatch(filtersActions.setPopularLocations(value));
  },
  setBoardName: (value: string[]) => {
    dispatch(filtersActions.setBoardName(value));
  },
  setRefundable: (value: string[]) => {
    dispatch(filtersActions.setRefundable(value));
  },
  setFlexibleDate: (value: string[]) => {
    dispatch(filtersActions.setFlexibleDate(value));
  },
  setNeighbourhoods: (value: string[]) => {
    dispatch(filtersActions.setNeighbourhoods(value));
  },
  setPlaces: (value: string[]) => {
    dispatch(filtersActions.setPlaces(value));
  },
  setStarRating: (value: number[]) => {
    dispatch(filtersActions.setStarRating(value));
  },
  setDistance: (value: number) => {
    dispatch(filtersActions.setDistance(value));
  },
  setSortBy: (value: string) => {
    dispatch(filtersActions.setSortBy(value as SortTypes));
  },
  resetFiltersByType: (type) => {
    dispatch(filtersActions.resetFiltersByType(type));
  },
  validateLocation: (error: string) => {
    dispatch(locationActions.setError(error));
  },
  setSelectedCompareHotels: (selectedCompareHotels: IHotel[]) => {
    dispatch(hotelsActions.setSelectedCompareHotels(selectedCompareHotels));
  },
  setBounds: (bounds: IBounds) => {
    dispatch(hotelsActions.setBounds(bounds));
  },
  setMapLoading: (isMapLoading: boolean) => {
    dispatch(hotelsActions.setMapLoading(isMapLoading));
  },
  setIsMapView: (isMapView: boolean) => {
    dispatch(hotelsActions.setIsMapView(isMapView));
  },
  setSearchHomes: (value: string) => {
    dispatch(filtersActions.setSearchHomes(value as HomesTypes));
  },
  setSelectedHotelSearchClientCash: (selectedClientCash: IClientCash) => {
    dispatch(hotelsActions.setSelectedHotelSearchClientCash(selectedClientCash));
  },
  getUserWallet: (user: IUser) => {
    dispatch(getUserWallet(user));
  },
  setLifeStyle: (value: string) => {
    dispatch(loginActions.setLifeStyle(value));
  },
});

const DashboardSearch = connect(mapStateToProps, mapDispatchToProps)(injectIntl(withRouter(DashboardSearchComponent)));
export default DashboardSearch;